<script>
import {formatVND} from "@/core/filters";
import {
    DIGITAL,
    FLASH_SALE,
    MONEY,
    OTHER_SCHOOL,
    PERCENT,
    PERIODIC_PROMOTIONS,
    SATELLITE,
    SCHOOL_LINK
} from "@/core/config/voucher_code/voucher_code";
import {GIFT_LIMIT_MESSAGE} from "@/core/services/contractService";

export default {
    name: "VoucherDialog",
    methods: {
        formatVND,
        openDetail(item) {
            this.$emit('openDetail', item)
        },
        pickPromotions(voucher, isCancel = false, isUseGift = false) {
            if (!isCancel && this.isVoucherDisabled(voucher)) {
                return;
            }
            if (+this.type === PERIODIC_PROMOTIONS || +this.type === DIGITAL || +this.type === 2) {
                // chương trình định kỳ: hủy từng voucher/quà tặng một, không hủy cả chương trình
                voucher.selected = false
                if (voucher.isGift) {
                    voucher.isUseGift = false
                }
            } else if (+this.type === DIGITAL || +this.type === 2) {
                this.allCode[this.type].forEach((code) => {
                    code.selected = false
                    if (!isUseGift && !voucher.isGift && code.isGift) {
                        code.isUseGift = true;
                    }
                })
            } else {
                voucher.selected = !voucher.selected
            }
            let selectedAmount = this.allCode[this.type].filter((e) => e.selected).length
            for (let key in this.allCode) {
                // if(+this.type === SCHOOL_LINK){
                this.allCode[key].forEach((code) => {
                    if (!isCancel) {
                        code.hidden = true
                    }
                    if (selectedAmount === 0 && isCancel) {
                        code.hidden = false
                    }
                })
                // }
                if (+key !== +this.type) {
                    this.allCode[key].forEach((code) => {
                        if (!isCancel) {
                            code.hidden = true
                        }
                        if (selectedAmount === 0 && isCancel) {
                            code.hidden = false
                        }
                    })
                }
            }
            this.$emit('pickPromotions');
        },
        applyVoucher(voucher, isUseGift = true) {
            if (this.isVoucherDisabled(voucher)) {
                return;
            }
            //chương trình định kỳ: áp dụng cả chương trình nhưng chỉ được 1 quà tặng
            if (+this.type === PERIODIC_PROMOTIONS) {
                this.applyPeriodicPromotion(voucher, true);
                return;
            }
            //ẩn hết các voucher và quà
            for (let key in this.allCode) {
                this.allCode[key].forEach((code) => {
                    code.hidden = true
                });
            }
            //if voucher là digital hoặc định kỳ thì chọn/huy tat cả
            if (+this.type === PERIODIC_PROMOTIONS || +this.type === DIGITAL) {
            //if voucher là digital thì chọn/huy tat cả
                this.allCode[this.type].forEach((code) => {
                    code.selected = !code.selected
                    if (!voucher.isGift && code.isGift) {
                        code.isUseGift = true
                    }
                });
                //cả chương trình được chọn cùng lúc nhưng chỉ nhận 1 bộ quà tặng
                this.keepOnlyFirstGift();
            } else {
                voucher.selected = !voucher.selected
                if (voucher.isGift) {
                    voucher.isUseGift = true
                }
            }
            this.$emit('pickPromotions');

            if (this.type == OTHER_SCHOOL || this.type == FLASH_SALE || this.type == SCHOOL_LINK || this.type == SATELLITE) {
                this.allCode[this.type].forEach((code) => {
                    code.hidden = false
                });
                //flash sale: áp dụng voucher thì nhận kèm quà, không áp dụng đè lên bộ quà người dùng đang chọn
                if (+this.type === FLASH_SALE && !voucher.isGift) {
                    this.autoTakeGift();
                }
                this.$emit('pickPromotions');
            }
        },
        changeVoucher(voucher) {
            if (this.isVoucherDisabled(voucher)) {
                return;
            }
            //chương trình định kỳ: chỉ quy đổi quà tặng được chọn, không quy đổi cả chương trình
            if (+this.type === PERIODIC_PROMOTIONS) {
                this.applyPeriodicPromotion(voucher, false);
                return;
            }
            if (voucher.program_id !== PERIODIC_PROMOTIONS && voucher.program_id !== DIGITAL) {
                voucher.selected = true;
                voucher.isUseGift = false;
                voucher.hidden = false;
                for (let key in this.allCode) {
                    this.allCode[key].forEach((code) => {
                        code.hidden = true
                    });
                }
                if (voucher.program_id == OTHER_SCHOOL || voucher.program_id == FLASH_SALE || voucher.program_id == SCHOOL_LINK || this.type == SATELLITE) {
                    this.allCode[voucher.program_id].forEach((code) => {
                        code.hidden = false
                    });
                }
                this.$emit('pickPromotions');
                return;
            }

            this.allCode[this.type].forEach((code) => {
                code.selected = !code.selected
                code.isUseGift = false;
            });
            for (let key in this.allCode) {
                this.allCode[key].forEach((code) => {
                    code.hidden = true
                });
            }
            this.$emit('pickPromotions');
        },
        changeIsUseGift(voucherId) {
            return this.arrayVoucher.includes(voucherId) ? 'Đã quy đổi voucher' : 'Đã áp dụng quà tặng';
        },
        isSchoolLinkVoucher(voucher) {
            return Number(voucher?.program_id) === SCHOOL_LINK;
        },
        isInvalidSchoolLinkVoucher(voucher) {
            if (!this.isSchoolLinkVoucher(voucher)) {
                return false;
            }

            const voucherSchools = Array.isArray(voucher?.truong_hoc) ? voucher.truong_hoc : [];
            const customerSchools = Array.isArray(this.customerSchoolId) ? this.customerSchoolId : (this.customerSchoolId ? [this.customerSchoolId] : []);

            return !customerSchools.length
                || voucherSchools.length === 0;
        },
        isSatellite(voucher) {
            return Number(voucher?.program_id) === SATELLITE;
        },
        isInvalidSatellite(voucher) {
            if (!this.isSatellite(voucher)) {
                return false;
            }

            return this.customerSource !== 'Vệ tinh'
        },
        //quà tặng đang được nhận, quà đã quy đổi (isUseGift = false) chỉ là voucher giảm giá nên không tính
        isGiftTaken(voucher) {
            return Boolean(voucher?.isGift) && Boolean(voucher.selected) && Boolean(voucher.isUseGift);
        },
        //bộ quà tặng đang được chọn của hợp đồng, tìm trên tất cả chương trình
        getSelectedGiftSet() {
            for (let key in this.allCode) {
                const giftTaken = (this.allCode[key] || []).find((code) => this.isGiftTaken(code));
                if (giftTaken) {
                    return giftTaken;
                }
            }

            return null;
        },
        //mỗi hợp đồng chỉ được 1 bộ quà tặng: đã chọn 1 bộ thì disable các bộ quà tặng còn lại
        isGiftLimitReached(voucher) {
            if (!voucher?.isGift) {
                return false;
            }

            const selectedGiftSet = this.getSelectedGiftSet();

            return Boolean(selectedGiftSet)
                && selectedGiftSet !== voucher
                && String(selectedGiftSet.id) !== String(voucher.id);
        },
        //nhận kèm 1 bộ quà tặng của chương trình, giữ nguyên nếu hợp đồng đã có bộ quà tặng được chọn
        autoTakeGift() {
            if (this.getSelectedGiftSet()) {
                return;
            }

            const gift = this.getGiftsOfCurrentProgram().find((code) => !this.isVoucherIneligible(code));
            if (!gift) {
                return;
            }

            gift.selected = true;
            gift.isUseGift = true;
        },
        //bỏ chọn các bộ quà tặng thừa của chương trình đang thao tác, chỉ giữ lại bộ quà đầu tiên
        keepOnlyFirstGift() {
            let hasGiftSet = false;
            (this.allCode[this.type] || []).forEach((code) => {
                if (!this.isGiftTaken(code)) {
                    return;
                }
                if (hasGiftSet) {
                    code.selected = false;
                    code.isUseGift = false;
                    return;
                }
                hasGiftSet = true;
            });
        },
        isVoucherDisabled(voucher) {
            return Boolean(voucher.hidden) || this.isVoucherIneligible(voucher) || this.isGiftLimitReached(voucher);
        },
        isVoucherIneligible(voucher) {
            return this.isInvalidSchoolLinkVoucher(voucher) || this.isInvalidSatellite(voucher);
        },
        getGiftsOfCurrentProgram() {
            return (this.allCode[this.type] || []).filter((code) => code.isGift);
        },
        giftNotice(voucher) {
            if (!voucher?.isGift) {
                return '';
            }

            if (this.isGiftLimitReached(voucher)) {
                return GIFT_LIMIT_MESSAGE;
            }

            const gifts = this.getGiftsOfCurrentProgram();

            return gifts.length > 1
                ? `Chương trình có ${gifts.length} bộ quà tặng, chỉ được áp dụng 1 bộ.`
                : '';
        },
        /**
         * Chương trình định kỳ: áp dụng cả chương trình nhưng chỉ cho phép 1 quà tặng.
         * isUseGift = true  -> nhận quà tặng (Áp dụng)
         * isUseGift = false -> quy đổi quà tặng thành voucher (Quy đổi voucher)
         */
        applyPeriodicPromotion(voucher, isUseGift) {
            const gifts = this.getGiftsOfCurrentProgram();

            if (voucher.isGift && this.isGiftLimitReached(voucher)) {
                this.$message.warning(`${GIFT_LIMIT_MESSAGE} Vui lòng hủy bộ quà tặng đang áp dụng trước.`);
                return;
            }

            //ẩn hết voucher và quà của các chương trình khác
            for (let key in this.allCode) {
                this.allCode[key].forEach((code) => {
                    code.hidden = true
                });
            }

            //giữ chương trình định kỳ ở trạng thái chọn/hủy được từng voucher, từng quà một
            this.allCode[this.type].forEach((code) => {
                code.hidden = false
                if (!code.isGift) {
                    code.selected = true
                    return;
                }
                if (code === voucher) {
                    code.selected = true
                    code.isUseGift = isUseGift
                    return;
                }
                //áp dụng từ voucher và chương trình chỉ có duy nhất 1 quà thì nhận luôn quà đó
                if (!voucher.isGift && gifts.length === 1) {
                    code.selected = true
                    code.isUseGift = true
                }
            });

            this.keepOnlyFirstGift();

            if (!voucher.isGift && gifts.length > 1) {
                this.$message.warning(`Chương trình định kỳ có ${gifts.length} bộ quà tặng, bạn chỉ được chọn 1 bộ quà tặng để áp dụng.`);
            }

            this.$emit('pickPromotions');
        },
        updateSchoolLinkInfo() {
            this.$emit('updateSchoolLinkInfo');
        }

    },
    props: {
        listCode: {
            type: Array,
            default() {
                return []
            }
        },
        colorCode: {
            type: String,
            default() {
                return '';
            }
        },
        allCode: {
            type: Object,
            default() {
                return {}
            }
        },
        type: {
            type: Number,
            default() {
                return null
            }
        },
        arrayVoucher: {
            type: Array,
            default() {
                return []
            }
        },
        customerSource: {
            type: String,
            default() {
                return '';
            }
        },
        customerSchoolId: {
            default() {
                return null;
            }
        }
    },
    data() {
        return {
            MONEY: MONEY,
            PERCENT: PERCENT,
            SCHOOL_LINK: SCHOOL_LINK
        }
    },
    computed: {
        sortedListCode() {
            return [...this.listCode].sort((firstVoucher, secondVoucher) => {
                return Number(this.isVoucherIneligible(firstVoucher)) - Number(this.isVoucherIneligible(secondVoucher));
            });
        }
    },

}
</script>

<template>
    <div>
        <div v-if="sortedListCode.length > 0">
            <div
                class="d-flex justify-content-between row-promotion w-100 voucher"
                :class="{'voucher--disabled': isVoucherDisabled(voucher)}"
                :style="{ border: `solid 1px ${colorCode}` }"
                v-for="(voucher, index) in sortedListCode"
                :key="voucher.id || 'd'+index"
            >
                <div class="col-md-2 voucher-image">
                    <div style="width:107px ; height:100%"
                         :style="{ border: `solid 1px ${colorCode}`, backgroundColor : `${colorCode}`}"
                         class=" d-flex align-items-center justify-content-center icon_image_voucher"
                    >
                        <div class="mt-4">
                            <img v-if="!voucher.isGift" src="../../../../../public/media/images/voucher.png" alt="">
                            <img v-if="voucher.isGift" src="../../../../../public/media/images/gift.png" alt="">
                            <p class="mt-2" style="color: white ; font-size: 13px">
                                {{ voucher.isGift ? 'Quà tặng' : 'Voucher' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 voucher-detail text-left mr-0 h-100 flex align-items-center mt-3">
                    <span style="font-size: 14px;font-weight: bold">{{ voucher.nameCode }}</span>
                    <div style="width: fit-content;font-size: 12px;padding: 5px;border-radius: 4px;color: white"
                         class="mt-2 voucher_value"
                         :style="{ backgroundColor : `${colorCode}`}" v-if="+voucher.value > 0">
                            <span class="discount" v-if="voucher.unit == MONEY">
                         <span v-if="!voucher.isGift">Giảm: </span>
                              <span v-else>Giá trị quy đổi voucher: </span>
                                {{ voucher.value | formatVND }}
                        </span>
                        <span class="discount" v-if="voucher.unit == PERCENT">
                         <span v-if="!voucher.isGift">Giảm: </span>
                              <span v-else>Giá trị quy đổi voucher: </span>
                           {{ voucher.value }}%
                        </span>
                    </div>
                    <div class="mt-2">
                        <img src="../../../../../public/media/images/time.png" alt="">
                        <span class="end_date mt-3" style="position: relative;top: 1px"
                              v-if="voucher.endDate"> Hiệu lực đến: {{ voucher.endDate }} </span>
                        <span class="end_date mt-3" style="position: relative;top: 1px"
                              v-if="!voucher.endDate"> Chưa có thời hạn </span>
                    </div>
                    <p @click="openDetail(voucher)" style="color:#2045C9;cursor: pointer;margin-top: 5px">Xem chi
                        tiết</p>
                    <p v-if="isInvalidSchoolLinkVoucher(voucher)" class="school-link-voucher-warning">
                        Trường học hoặc kênh khách hàng không hợp lệ.
                        <span @click="updateSchoolLinkInfo">Cập nhật ngay?</span>
                    </p>
                    <p v-if="isInvalidSatellite(voucher)" class="school-link-voucher-warning">
                        Kênh khách hàng không thuộc Kênh Vệ tinh.
                        <span @click="updateSchoolLinkInfo">Cập nhật ngay?</span>
                    </p>
                    <p v-if="giftNotice(voucher)" class="gift-warning">
                        {{ giftNotice(voucher) }}
                    </p>
                </div>
                <div class="col-md-3 voucher-action d-flex align-items-center justify-content-center"
                     v-if="!voucher.isGift">
                    <button v-if="!voucher.selected" type="button" class="btn btn-outline-primary select"
                            :class="{'btn-outline-secondary': isVoucherDisabled(voucher), 'voucher-active': !isVoucherDisabled(voucher)}"
                            :disabled="isVoucherDisabled(voucher)"
                            @click="applyVoucher(voucher)">Áp dụng
                    </button>
                    <button v-if="voucher.selected" type="button" @click="pickPromotions(voucher,true)"
                            class="btn btn-danger">Hủy áp
                        dụng
                    </button>
                </div>
                <div class="col-md-3 voucher-action flex align-items-center text-center" v-else>
                    <button v-if="!voucher.selected" type="button" class="btn btn-primary"
                            :class="{'btn-secondary': isVoucherDisabled(voucher)}"
                            :disabled="isVoucherDisabled(voucher)"
                            @click="applyVoucher(voucher)">Áp dụng
                    </button>
                    <br class="hidden br">
                    <button v-if="!voucher.selected && +voucher.value > 0" type="button"
                            class="btn btn-outline-primary mt-3"
                            :class="{'btn-outline-secondary': isVoucherDisabled(voucher)}"
                            :disabled="isVoucherDisabled(voucher)"
                            @click="changeVoucher(voucher)">Quy đổi voucher
                    </button>
                    <p v-if="voucher.selected" class="mt-2 mb-2">
                        {{ voucher.isUseGift ? changeIsUseGift(voucher.id) : 'Đã quy đổi voucher' }}</p>
                    <button v-if="voucher.selected" type="button" @click="pickPromotions(voucher,true)"
                            class="btn btn-danger">Hủy áp
                        dụng
                    </button>
                </div>
            </div>
        </div>
        <div v-else class="no-promotion">
            <p>Không có voucher</p>
        </div>
    </div>
</template>

<style scoped>
.school-link-voucher-warning {
    color: red;
    font-size: 12px;
    margin: 6px 0 0;
}

.school-link-voucher-warning span {
    color: #2045C9;
    cursor: pointer;
}

.gift-warning {
    color: #E6A23C;
    font-size: 12px;
    margin: 6px 0 0;
}

@media only screen and (max-width: 767px) {
    .voucher {
        display: block !important;
        padding-bottom: 10px !important;
    }

    .voucher-image {
        padding: 0 !important;
    }

    .icon_image_voucher {
        width: 100% !important;
        height: 85px !important;
    }

    .voucher-detail {
        text-align: center !important;
    }

    .voucher_value {
        width: 100% !important;
    }

    .br {
        display: block !important;
    }
}

.school-link-warning {
    color: red;
    font-size: 12px;
    margin-top: 6px;
}

.school-link-warning__action {
    color: #2045C9;
    cursor: pointer;
}

.voucher-active {
    border: 2px solid #886ab5;
    font-weight: 700;
}

.voucher--disabled .voucher-image,
.voucher--disabled .voucher-action,
.voucher--disabled .voucher-detail > *:not(.school-link-voucher-warning) {
    opacity: 0.45;
}

.voucher {
    min-height: 132px;
    margin-bottom: 12px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 5px rgba(31, 45, 61, 0.12);
}

.voucher-image {
    flex: 0 0 108px;
    max-width: 108px;
    padding: 0;
}

.voucher-detail {
    flex: 1 1 auto;
    max-width: none;
    padding: 0 16px;
}

.voucher-action {
    flex: 0 0 180px;
    max-width: 180px;
}
</style>
